import "./lib/leadAttribution";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

if (import.meta.env.DEV && location.pathname === '/__motion-study') {
  import('./rebuild/MotionStudy').then(({default:Study})=>import('react-router-dom').then(({BrowserRouter})=>createRoot(document.getElementById('root')!).render(<BrowserRouter><Study/></BrowserRouter>)));
} else createRoot(document.getElementById("root")!).render(<App />);
